import {
  OPCOES_FORNECEDOR,
  OPCOES_PRENSA,
} from "../constants/opcoesSolicitarAutorizacao";

export function rotuloFornecedor(fornecedor: string): string {
  return (
    OPCOES_FORNECEDOR.find(({ value }) => value === fornecedor)?.label ??
    fornecedor
  );
}

export function rotuloPrensa(prensa: number): string {
  return (
    OPCOES_PRENSA.find(({ value }) => value === prensa)?.label ?? String(prensa)
  );
}

export function rotuloPrensas(prensas: number[]): string | null {
  return prensas.length ? prensas.map(rotuloPrensa).join(", ") : null;
}
